import { Component } from 'react'

//
import { Text } from '@react-pdf/renderer'
import React from 'react'
import '../../utils/fonts'

export type ErrorBoundaryProps = {
	onError?: any
	errorMessage?: any
	message?: any
	children?: any
}

export type ErrorBoundaryStateProps = {
	error: boolean
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryStateProps> {
	state = {
		error: false,
	}

	static getDerivedStateFromError() {
		return { error: true }
	}

	componentDidCatch(error: any, errorInfo: any) {
		if (typeof this.props?.onError === 'function') {
			return this.props.onError(error, errorInfo)
		}
	}

	render() {
		if (this.state.error) {
			console.error(
				'ErrorBoundary caught an error:',
				this.props?.errorMessage ?? this.props?.message
			)
			return (
				<Text>
					{this.props?.message ?? this.props?.errorMessage ?? `Error rendering view`}
				</Text>
			)
		} else {
			return this.props.children
		}
	}
}
